import React from 'react';
import styled from 'styled-components';
import { Container, Title, BrandText } from '../../../styles/components';
import { Logo } from '../../Logo';
import { colors, typography } from '../../../styles/theme/index';

const PageWrapper = styled(Container)`
  background-color: #f1f7f3;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    background-color: #ffffff;
    padding: 0;
  }
`;

const WhiteContainer = styled.div`
  background: white;
  border-radius: 24px;
  padding: 20px;
  width: 90%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    width: 100%;
    border-radius: 0;
    padding: 16px;
    min-height: 100vh;
  }
`;

const TopLeftLogo = styled.div`
  position: absolute;
  top: 30px;
  left: 30px;
  opacity: 1;
  transform: scale(0.8);

  @media screen and (max-width: 480px) {
    position: static;
    margin: 10px auto;
    transform: scale(0.7);
  }
`;

const StyledTitle = styled(Title)`
  text-align: center;
  margin: 80px 0 40px;
  padding-top: 20px;
  width: 100%;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media screen and (max-width: 480px) {
    margin: 10px 0 20px;
    padding-top: 0;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 120px;
  flex: 1;
  margin-bottom: 10px;

  @media screen and (max-width: 480px) {
    padding-bottom: 80px;
    margin-bottom: 100px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  bottom: 220px;
  left: 50px;
  background: none;
  border: none;
  color: ${colors.text.secondary};
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;

  @media screen and (max-width: 480px) {
    position: static;
    margin: 20px auto;
  }

  &:hover {
    color: ${colors.primary};
  }
`;

const Disclosure = styled.div`
  width: 100%;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xs};
  color: ${colors.text.secondary};
  text-align: center;
  line-height: 1.2;
  margin-bottom: 30px;

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media screen and (max-width: 480px) {
    margin-bottom: 20px;
  }
`;

export const RegulationDisclosure = styled.div`
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.xs};
  color: ${colors.text.secondary};
  text-align: center;
  line-height: 1.4;
  position: relative;
  margin-bottom: 40px;

  @media screen and (max-width: 480px) {
    margin-bottom: 30px;
  }
`;

const OnboardingLayout = ({ 
  children, 
  title, 
  brandText, 
  onBack,
  showBackButton = true 
}) => {
  return (
    <PageWrapper>
      <WhiteContainer>
        <TopLeftLogo>
          <Logo />
        </TopLeftLogo>

        {title && (
          <StyledTitle>
            {title} {brandText && <BrandText>{brandText}</BrandText>}
          </StyledTitle>
        )}

        <ContentContainer>
          {children}
        </ContentContainer>

        <RegulationDisclosure>
          Planet Protection is a trading name of Planet Protection LTD which is registered in England and Wales under company number 15384818. Planet Protection LTD is an Appointed Representative of Innovative Risk Labs Ltd, which is authorised and regulated by the Financial Conduct Authority with firm reference number 609155.
        </RegulationDisclosure>
        <Disclosure>
          By using this service you are agreeing to Planet Protection's <a href="/assets/Planet_Protection_TOBA.pdf" target="_blank" rel="noopener noreferrer">terms of business</a>.
        </Disclosure>

        {showBackButton && onBack && (
          <BackButton onClick={onBack}>← Back</BackButton>
        )}
      </WhiteContainer>
    </PageWrapper>
  );
};

export default OnboardingLayout; 